export default function PageHeader({ eyebrow, title, lede, testId = "page-header" }) {
  return (
    <section className="relative pt-24 lg:pt-32 pb-16 lg:pb-20 bg-white border-b border-borderSubtle" data-testid={testId}>
      <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" aria-hidden />
      <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          {eyebrow && <p className="eyebrow text-gold" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>}
          <h1
            data-testid={`${testId}-title`}
            className="mt-5 font-display font-black text-navy-900 tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl"
          >
            {title}
          </h1>
          {lede && (
            <p className="mt-6 text-lg lg:text-xl text-slateSoft leading-relaxed max-w-2xl" data-testid={`${testId}-lede`}>
              {lede}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
